<template>
    <div>
        <b-row sm="10">
            <b-col sm="4" class="col text-right"
                ><label>รหัสสินค้า</label></b-col
            >
            <b-col sm="6">
                <multiselect
                    v-model="form.product_code"
                    :options="optionProduct"
                    :custom-label="LabelProduct"
                    track-by="code">
                </multiselect>
            </b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right"><label>ชีท</label></b-col>
            <b-col sm="6"><input class="form-control" type="text"/></b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right"
                ><label>เครื่องขึ้นรูป</label></b-col
            >
            <b-col sm="6">
                <multiselect
                    v-model="form.machine"
                    :options="optionMachine"
                    :custom-label="LabelMachine"
                    track-by="code"
                >
                </multiselect>
            </b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"
                ><label>วันที่เริ่มผลิต</label></b-col
            >
            <b-col sm="6"> <input class="form-control" type="date" /> </b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"
                ><label>เวลาเริ่มผลิต</label></b-col
            >
            <b-col sm="6"><input class="form-control" type="time"/></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"><label>กะ เริ่ม</label></b-col>
            <b-col sm="6"><input class="form-control" type="text"/></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"
                ><label>วันที่สิ้นสุดการผลิต</label></b-col
            >
            <b-col sm="6"><input class="form-control" type="date"/></b-col>
        </b-row>
        <br />
        <b-row sm="10">
            <b-col sm="4" class="col text-right"
                ><label>เวลาสิ้นสุดการผลิต</label></b-col
            >
            <b-col sm="6"><input class="form-control" type="time"/></b-col>
        </b-row>
        <br />
        <b-row>
            <b-col sm="4" class="col text-right"
                ><label>กะ สิ้นสุด</label></b-col
            >
            <b-col sm="6"><input class="form-control" type="text"/></b-col>
        </b-row>
        <br />
        <b-row sm="11">
            <b-col sm="4" class="col text-right"><label>หมายเหตุ</label></b-col>
            <b-col sm="6"><input class="form-control" type="text"/></b-col>
        </b-row>
        <br />
        <b-row>
            <div class="col text-center">
                <button type="button" class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon> บันทึก</button
                >&nbsp&nbsp
                <button type="button" class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>

        <!-- <pre class="alert alert-primary">{{ form }}</pre> -->
    </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";

export default {
    name: "add-product-modal",
    components: { Multiselect },
    created() {
        this.getCurrentDate();
        this.$store.dispatch("Products/setProducts");
        this.$store.dispatch("Machine/get");
    },
    computed: {
        ...mapState({
            optionProduct: state => {
                return [
                    ...state.Products.data.map(product => ({
                        code: product.code
                    }))
                ];
            },
            optionMachine: state => {
                return [
                    ...state.Machine.data.map(machine => ({
                        code: machine.machine_id
                    }))
                ];
            },
            form: state => {
                return state.ReportProduct.Form;
            }
        })
    },
    methods: {
        getCurrentDate() {
            const currentDate = moment().format("YYYY-MM-DD");
            const currentTime = moment().format("HH:mm");
        },
        LabelProduct(option) {
            return `${option.code}`;
        },
        LabelMachine(option) {
            return `${option.code}`;
        }
    }
};
</script>

<style scoped></style>
